import React from "react";

import "./StartQuizStatus.scss";
import { useNavigate } from "react-router-dom";

export default function StartQuizStatus() {
  const navigate = useNavigate();
  return (
    <div className="start_status_container">
      <div className="resume_status_container">
        <h2 className="topic_title">General Embryology</h2>
        <div className="status_card">
          <h4 className="subject_title">Anatomy</h4>
          <h3 className="quiz_title">Developmental period 1,2,3 & 4</h3>
          <div className="status_info">
            <div className="total_questions">20 Questions</div>
          </div>
          <button
            className="button button_primary"
            onClick={() => navigate("/qbanks/1/topicIdxyz/playquiz")}
          >
            Start QBank
          </button>
        </div>
      </div>
    </div>
  );
}
